export const childOf = (children: ParentNode | null, parent: Element | null): boolean => {
  if (!children) return false;
  while ((children = children.parentNode) && children !== parent);
  return !!children;
};
